import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List } from 'immutable';
import classNames from 'classnames';

import Tabs from '../helpers/Tabs';

import style from './style.module.css';

const DirectorDashboardComponent = ({ tabs, children }) => (
  <div className="container-fluid pl0 pr0">
    <Tabs tabClass={classNames('nav', style.directorDashboardTabs)} tabs={tabs} />
    <div className={style.directorDashboardPage}>
      <div className="tab-content">{children}</div>
    </div>
  </div>
);

DirectorDashboardComponent.propTypes = {
  tabs: PropTypes.instanceOf(List).isRequired,
};

/** Director dashboard component. */
export const DirectorDashboard = memo(DirectorDashboardComponent);
